<div class="header">
    <button mat-flat-button (click)="onBack()" class="back-btn">
      <mat-icon>arrow_back</mat-icon>{{ backButtonLabel }}
    </button>
  </div>
  <div class="container-top">
    <div class="user-status-top">
      <div>
        <b
          ><strong>{{ title }}</strong></b
        >
      </div>
      <div [formGroup]="form">
        <div
          *ngFor="let field of fieldObject[0].formsData"
          class="inner-container"
        >
          <mat-label
            >{{ field.formFieldLabelName }}
            <span class="required" *ngIf="field.required">*</span></mat-label
          >
          <ng-container *ngIf="field.type === 'matformField'">
            <mat-form-field
              appearance="outline"
              class="full-width custom-outline-field"
            >
              <input
                matInput
                [placeholder]="field.placeholder"
                [formControlName]="field.formControllName"
                [attr.readonly]="field.readonly ? true : null"
                [attr.disabled]="field.disabled ? true : null"
                [required]="field.required"
              />
              <mat-error
                *ngIf="
                  form.get(field.formControllName)?.touched &&
                  form.get(field.formControllName)?.invalid
                "
              >
                {{ field.formFieldLabelName }} is required
              </mat-error>
            </mat-form-field>
          </ng-container>
          <ng-container *ngIf="field.type === 'dropdown'">
            <mat-form-field
              appearance="outline"
              class="full-width custom-outline-field"
            >
              <mat-select
                [formControlName]="field.formControllName"
                [required]="field.required"
                [attr.disabled]="field.disabled ? true : null"
              >
                <mat-option
                  *ngFor="let option of field.dropdownValue"
                  [value]="option.id"
                >
                  {{ option.value }}
                </mat-option>
              </mat-select>
              <mat-error
                *ngIf="
                  form.get(field.formControllName)?.touched &&
                  form.get(field.formControllName)?.invalid
                "
              >
                {{ field.formFieldLabelName }} is required
              </mat-error>
            </mat-form-field>
          </ng-container>
        </div>
      </div>
  
      <div class="btn-actions">
        <button
          mat-flat-button
          (click)="onReset()"
          *ngIf="abacService.verifyAccess('Reset')"
          class="reset-button"
        >
          {{ resetButtonLabel }}
        </button>
        <button
          mat-flat-button
          (click)="onSave()"
          *ngIf="abacService.verifyAccess('Update')"
          class="save-button"
        >
          {{ saveButtonLabel }}
        </button>
      </div>
    </div>
  </div>
  